// Pagination texts
export const PAGINATION_TEXTS = {
  displayedRows: (from: number, to: number, count: number) =>
    `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`,
  firstPage: 'First page',
  lastPage: 'Last page',
  nextPage: 'Next page',
  previousPage: 'Previous page'
} as const;